export function getNamefromList(list, id) {
  const item = list.filter((x) => x.id === id);
  return item && item.length > 0 ? item[0].name : "";
}
